import React, { useEffect } from 'react';
import { Tabs, Typography, Card, Grid } from 'antd';
import { UserOutlined, LockOutlined, BellOutlined, SettingOutlined, BgColorsOutlined } from '@ant-design/icons';
import ProfilePage from './ProfilePage'; // Reusing existing ProfilePage
import SecuritySettings from '../components/settings/SecuritySettings';
import NotificationSettings from '../components/settings/NotificationSettings';
import SystemSettings from '../components/settings/SystemSettings';
import ThemeSettings from '../components/settings/ThemeSettings';
import { usePageHeader } from '../context/PageHeaderContext';

const { Title } = Typography;
const { useBreakpoint } = Grid;

const SettingsPage = () => {
  const { setPageTitle } = usePageHeader();
  const screens = useBreakpoint();
  const isMobile = !screens.md; // md is 768px

  useEffect(() => {
    setPageTitle('Settings');
    return () => setPageTitle('');
  }, [setPageTitle]);

  const items = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined />
          Profile
        </span>
      ),
      children: <ProfilePage />,
    },
    {
      key: '2',
      label: (
        <span>
          <LockOutlined />
          Security
        </span>
      ),
      children: <SecuritySettings />,
    },
    {
      key: '3',
      label: (
        <span>
          <BellOutlined />
          Notifications
        </span>
      ),
      children: <NotificationSettings />,
    },
    {
      key: '4',
      label: (
        <span>
          <SettingOutlined />
          System
        </span>
      ),
      children: <SystemSettings />,
    },
    {
      key: '5',
      label: (
        <span>
          <BgColorsOutlined />
          Appearance
        </span>
      ),
      children: <ThemeSettings />,
    },
  ];

  return (
    <div style={{ padding: isMobile ? '12px' : '24px' }}>
      {!isMobile && <Title level={2}>Settings</Title>}
      <Card bodyStyle={{ padding: isMobile ? '12px' : '24px' }}>
        <Tabs
          defaultActiveKey="1"
          items={items}
          tabPosition={isMobile ? "top" : "left"}
        />
      </Card>
    </div>
  );
};

export default SettingsPage;
